var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelopmentEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "48px",
    viewBox: "0 0 39 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FC30BF9A-A13E-4BF6-BCA0-070ED345AF80") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.501044695
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Development-Plan---Empty",
    transform: "translate(-700.000000, -605.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "development-empty",
    transform: "translate(701.000000, 606.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25,27.2348385 L1.25,3.70003189 C6.3779189,-1.03660201 12.3248886,-0.57083357 19.0909091,5.09733722 C25.8569296,10.765508 31.5766266,10.765508 36.25,5.09733722 L36.25,28.8819353 C29.8303855,31.8102967 23.4339678,31.0461796 17.0607468,26.5895841 C10.6875258,22.1329885 5.41727688,22.3480733 1.25,27.2348385 Z",
    id: "Path-2",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.25,
    y1: 4.93685083,
    x2: 1.25,
    y2: 44.9368508,
    id: "Path",
    stroke: "#9C9C9C",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.25,
    y1: 4.93685083,
    x2: 36.25,
    y2: 27.4368508,
    id: "Path",
    stroke: "#9C9C9C",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25,4.93685083 C6.11054388,0.172564876 13.8894561,0.172564876 18.75,4.93685083 C23.6105439,9.70113678 31.3894561,9.70113678 36.25,4.93685083",
    id: "Path",
    stroke: "#9C9C9C",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25,27.4368508 C6.11054388,22.6725649 13.8894561,22.6725649 18.75,27.4368508 C23.6105439,32.2011368 31.3894561,32.2011368 36.25,27.4368508",
    id: "Path",
    stroke: "#9C9C9C",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentEmpty);
export default __webpack_public_path__ + "static/media/development-empty.5ea8bbb3.svg";
export { ForwardRef as ReactComponent };